module.exports = __webpack_public_path__ + "static/media/RTTL2IMelody_v0.4.77906560.rar";